<template>
    <li>
        <div class="title"><span>プライス</span></div>
        <div class="detail">
            <p><span>¥{{ Number($store.state.register.form.price_min).toLocaleString() }} 〜 ¥{{ Number($store.state.register.form.price_max).toLocaleString() }}</span></p>
        </div>
    </li>
</template>